export default __webpack_public_path__ + "static/media/empty.11920730.jpg";